export default __webpack_public_path__ + "static/qr-code-0ba74a5ae92be4c8f540763a1d0eca27.png";